import * as React from 'react';
import { IItemCardButtonsProps } from 'models/itemcard/itemcardbuttons';
import renderIcon from 'helpers/renderIcon';

class ItemCardButtons extends React.Component<IItemCardButtonsProps, any> {
	public render() {
		let editButton: JSX.Element = null;
		if (this.props.editItem) {
			editButton = (
				<span className="cardButton editButton" onClick={this.props.editItem}>
					<img src={require('containers/Html/icons/actionIcons/edit.svg')} />
				</span>
			);
		}

		let deleteButton: JSX.Element = null;
		if (this.props.deleteItem) {
			deleteButton = (
				<span className="cardButton deleteButton" onClick={this.props.deleteItem}>
					<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
				</span>
			);
		}

		let removeButton: JSX.Element = null;
		if (this.props.removeItem) {
			removeButton = (
				<span className="cardButton deleteButton" onClick={this.props.removeItem}>
					<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
				</span>
			);
		}

		// Added copy, view and settings buttons
		let copyButton: JSX.Element = null;
		if (this.props.copyItem) {
			copyButton = (
				<span className="cardButton copyButton" onClick={this.props.copyItem}>
					<img src={require('containers/Html/icons/actionIcons/copy.svg')} />
				</span>
			);
		}

		let viewButton: JSX.Element = null;
		if (this.props.viewItem) {
			viewButton = (
				<span className="cardButton viewButton" onClick={this.props.viewItem}>
					<img src={require('containers/Html/icons/actionIcons/view.svg')} />
				</span>
			);
		}

		let settingsButton: JSX.Element = null;
		if (this.props.settingsItem) {
			settingsButton = (
				<span className="cardButton settingsButton" onClick={this.props.settingsItem}>
					<img src={require('containers/Html/icons/actionIcons/settings.svg')} />
				</span>
			);
		}

		let deleteButtonWhite: JSX.Element = null;
		if (this.props.deleteItemWhite) {
			deleteButtonWhite = (
				<span className="cardButton" onClick={this.props.deleteItemWhite}>
					{renderIcon('deleteWhite')}
				</span>
			);
		}

		let editButtonWhite: JSX.Element = null;
		if (this.props.editItemWhite) {
			editButtonWhite = (
				<span className="cardButton" onClick={this.props.editItemWhite}>
					{renderIcon('editWhite')}
				</span>
			);
		}

		return (
			<div className="itemCardButtons">
				{editButton}
				{settingsButton}
				{copyButton}
				{deleteButton}
				{viewButton}
				{removeButton}
				{deleteButtonWhite}
				{editButtonWhite}
			</div>
		);
	}
}

export { ItemCardButtons };
